import styled from 'styled-components';
import { Card } from 'ui/card/Card';
import { colors, smallShadow, spacing, textColors } from 'ui/theme';

export const Ul = styled.ul`
  padding-left: ${spacing.base};
  margin-bottom: 0;

  > li {
    list-style-type: disc;
    word-break: break-word;

    span {
      display: inline-block;

      + span {
        margin-left: ${spacing.quarter};
      }
    }
  }
`;

export const EmptyStateCard = styled(Card)`
  width: 100%;
  height: ${spacing.x6};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing.base} ${spacing.plusHalf};
  border-radius: ${spacing.half};
  background-color: ${colors.white};
  ${smallShadow}

  & p {
    color: ${textColors.textSecondary};
  }
`;
